import { createFileRoute } from '@tanstack/react-router'
import ProfileSettings from '@/pages/settings/profile'

export const Route = createFileRoute(
  '/(protected)/settings/profile'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileSettings />
}
